import React from 'react';

import { keyframes } from '@emotion/react'; // keyframes를 사용하기 위해 @emotion/react에서 import
import styled from '@emotion/styled';

import { colors } from '@/styles/color';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Spinner = () => (
	<>
		<CustomS.SpinnerContainer>
			<CustomS.SpinnerElement />
		</CustomS.SpinnerContainer>
	</>
);

export default Spinner;

const CustomS = {
	SpinnerContainer: styled.div`
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: rgba(255, 255, 255, 0.7); /* 반투명 배경 오버레이 */
		z-index: 9999; /* 다른 요소 위에 표시 */
	`,

	SpinnerElement: styled.div`
		width: 50px;
		height: 50px;
		border: 5px solid rgba(0, 0, 0, 0.1); /* 스피너의 테두리 (배경색) */
		border-left-color: ${colors.primary400}; /* 스피너의 움직이는 부분 색상 */
		border-radius: 50%; /* 원형으로 만듦 */
		animation: ${spin} 1s linear infinite; /* 위에서 정의한 spin keyframes 적용 */
	`,
};
